import Formatter from 'shared/utils/formatters'

export default class TipoEmpresa {
  naturezaJuridica: string

  // SA
  isSA(naturezaJuridica: string): boolean {
    this.naturezaJuridica = naturezaJuridica
    return ['2046', '2054'].includes(
      this.naturezaJuridica?.replace(Formatter.somenteNumeros(), ''),
    )
  }

  // EIRELI/MEI/EI
  isMEI(naturezaJuridica: string): boolean {
    this.naturezaJuridica = naturezaJuridica
    return ['2135', '2305', '2313'].includes(
      this.naturezaJuridica?.replace(Formatter.somenteNumeros(), ''),
    )
  }
}
